import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import DatePicker from "react-datepicker";
import CustomDatePickerInput from "../../_common/CustomDatePickerInput";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import cmtStageActions from "../../../_actions/_qmsActions/cmtStageActions";
import { getLocalISOString } from "../../../_utils/generalUtils";
import BadgeContainer from "../../_common/BadgeContainer";
import Badge from "../../_common/Badge";

export default function CmtModal_AddIssueStagePostAttachments(props) {
  const { showModal, toggleModal, issueStageId, addFiles } = props;

  const fetching = useSelector((state) => state.qms.fetching);

  const [filesToAdd, setFilesToAdd] = useState([]);

  const handleChange_fileInput = (e) => {
    // Must shallow-copy
    let existFiles = [...filesToAdd];
    const newFiles = Array.from(e.target.files);
    const _files = existFiles.concat(newFiles);
    setFilesToAdd(_files);
  };

  const removeFileToUpload = (fileIndex) => {
    // Must shallow-copy
    let _files = [...filesToAdd];
    _files.splice(fileIndex, 1);
    setFilesToAdd(_files);
  };

  const handleClick_submit = (e) => {
    e.preventDefault();
    addFiles(filesToAdd);
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={showModal} toggle={toggleModal} fade={false} size={"lg"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="paperclip" className="fa-fw mr-2" />
        Add Attachments
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="form-group col-12 mb-2">
            <label htmlFor="file" className="mb-0">
              <b>Attachments:</b>
            </label>
            <div className="custom-file">
              <input
                type="file"
                id="file"
                name="file"
                className="custom-file-input"
                onChange={handleChange_fileInput}
                accept=".docx,.xlsx,.txt,.csv,.pdf,.jpg,.jpeg,.gif"
                multiple
              />
              <label htmlFor="file" className="custom-file-label">
                Choose files...
              </label>
            </div>
          </div>
        </div>
        {filesToAdd.length > 0 && (
          <div className="row">
            <div className="col">
              <BadgeContainer>
                {filesToAdd.map((f, index) => (
                  <Badge
                    className="mr-1"
                    key={`fileLabelIndex_${index}`}
                    itemId={index}
                    clickItem={() => {}}
                    deleteItem={removeFileToUpload}
                    label={f.name}
                    showDelete={true}
                  />
                ))}
              </BadgeContainer>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="form-group form-row form-inline float-right mb-0">
          <input
            type="submit"
            name="submit"
            id="submit"
            value="Submit"
            form="cmtAddIssueForm"
            className="btn btn-primary mr-2 font-weight-bold"
            onClick={handleClick_submit}
          />
          {fetching && (
            <span className="mr-2 mt-1">
              <FontAwesomeIcon
                icon="spinner"
                className="loading-spinner"
                style={{ color: "white" }}
              />
            </span>
          )}
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
